export const LOGS_ASSESSMENT = '/logs/assessment'
